import { marginBottom, marginTop, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import styled from "styled-components";
export const StepTitle = styled.h1`
  ${typography.title}
  color: ${({
  theme
}) => applyOpacity(theme.colours.dark, 0.8)};
  text-align: center;
  ${marginTop.zero}
  ${marginBottom.m}
  &::first-letter {
    text-transform: capitalize;
  }
`;
export default StepTitle;